import { IconProps } from './common';

const EyeIcon = ({ ...props }: IconProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 4.25C5.83344 4.25 2.2751 6.84167 0.833435 10.5C2.2751 14.1583 5.83344 16.75 10.0001 16.75C14.1668 16.75 17.7251 14.1583 19.1668 10.5C17.7251 6.84167 14.1668 4.25 10.0001 4.25ZM10.0001 14.6664C7.70005 14.6664 5.83339 12.7998 5.83339 10.4998C5.83339 8.19977 7.70005 6.3331 10.0001 6.3331C12.3001 6.3331 14.1667 8.19977 14.1667 10.4998C14.1667 12.7998 12.3001 14.6664 10.0001 14.6664ZM7.49994 10.5C7.49994 9.11667 8.61661 8 9.99994 8C11.3833 8 12.4999 9.11667 12.4999 10.5C12.4999 11.8833 11.3833 13 9.99994 13C8.61661 13 7.49994 11.8833 7.49994 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export default EyeIcon;
